import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../../utils/helper';

export const headerClasses = generateClasses('Header', ['titleForm']);

export const Root = styled((props: StackProps) => <Stack direction="row" alignItems="center" gap={2} {...props} />)(
  ({ theme }) => ({
    [`& .${headerClasses.titleForm}`]: {
      flex: 1,
    },
  })
);
